import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	completedName: {
		id: 'software-burnup-report.chart.completed-name',
		defaultMessage: 'Completed work',
		description: 'Legend title for completion line on burnup',
	},
	remainingStoriesDescription: {
		id: 'software-burnup-report.chart.remaining-stories-description',
		defaultMessage: 'Number of story points completed this sprint',
		description: 'Legend description for story points completion line on burnup',
	},
	remainingTimeDescription: {
		id: 'software-burnup-report.chart.remaining-time-description',
		defaultMessage: 'Hours of work completed this sprint',
		description: 'Legend description for time completion line on burnup',
	},
	remainingIssuesDescription: {
		id: 'software-burnup-report.chart.remaining-issues-description',
		defaultMessage: 'Number of issues completed this sprint',
		description: 'Legend description for issue count completion line on burnup',
	},
	guidelineName: {
		id: 'software-burnup-report.chart.guideline-name',
		defaultMessage: 'Guideline',
		description: 'Legend title for guideline on burnup',
	},
	guidelineDescription: {
		id: 'software-burnup-report.chart.guideline-description',
		defaultMessage: 'Ideal burn rate',
		description: 'Legend description for guideline on burnup',
	},
	scope: {
		id: 'software-burnup-report.chart.scope',
		defaultMessage: 'Work Scope',
		description: 'Legend title for work scope line',
	},
	scopeStories: {
		id: 'software-burnup-report.chart.scope-stories',
		defaultMessage: 'Number of story points to be completed this sprint',
		description: 'Legend description for story points for the scope line on burnup',
	},
	scopeTime: {
		id: 'software-burnup-report.chart.scope-time',
		defaultMessage: 'Hours of work to be completed this sprint',
		description: 'Legend description for time for the scope line on burnup',
	},
	scopeIssues: {
		id: 'software-burnup-report.chart.scope-issues',
		defaultMessage: 'Number of issues to be completed this sprint',
		description: 'Legend description for issue count for the scope line on burnup',
	},
});
